import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
} from "@material-ui/core";
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";
import { useHistory } from "react-router-dom";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

/** Local deoendencies & Libraries */
import Services from '../../../Services';
import { seriliazeParams } from "../../../helpers/seriliazeParams";
import { hireITColumn } from "../../../Components/TableComponents/constants";
import DynamicTable from "../../../Components/TableComponents/DynamicTable";
import PageLayout from "../../../Components/LayoutComponents/PageLayout";


const {
  IT
} = Services;


const NewHireQueueIT = () => {

  let history = useHistory();

  const [applicantData, setApplicantData] = useState([])

  const retrieveListing = async (offset = 0, limit = 1000) => {
    let params = '?'.concat(seriliazeParams({ offset, limit }))
    try {
      let data = await IT.list_it_request({ params });
      if (data?.httpStatus == 200) {
        data = data.data.rows;
        data.forEach(row => {
          row.name = `${row?.Employee?.firstName || row?.Applicant?.firstName || ""} ${row?.Employee?.lastName || row?.Applicant?.lastName || ""} `
          row.deptName = row?.Employee?.SubDepartment?.name || row?.Applicant?.SubDepartment?.name || ""
          row.AD_text = (row.AD) ? 'Yes' : 'No'
          row.computer_text = (row.computer) ? 'Yes' : 'No'
          row.cell_phone_text = (row.cell_phone) ? 'Yes' : 'No'
          row.company_vehicle_text = (row.company_vehicle) ? 'Yes' : 'No'
          row.fuel_card_text = (row.fuel_card) ? 'Yes' : 'No'
        });

        setApplicantData(data);
      }
    }
    catch (exc) {

    }
  }

  useEffect(async () => {
    retrieveListing();
  }, [])


  function onClickView(value) {

    history.push({
      pathname: "/on-borarding",
      state: value
    });
  }

  const hireIT = {
    header: hireITColumn,
    rows: applicantData.map(row => [
      row?.id,
      row?.name,
      row?.deptName,
      row?.AD_text,
      row?.computer_text,
      row?.cell_phone_text,
      row?.company_vehicle_text,
      row?.fuel_card_text,
      row.complete ? <VisibilityOffIcon style={{ width: "30px", fontSize: "17px" }} /> : <Button
        onClick={() => onClickView(row)}
        className="ViewIcon"
      >
      </Button>,
      <Grid className={`CompleteIcon ${(row.complete) ? `completeTrue` : ``}`} ></Grid>
    ])
  }


  return (
    <PageLayout className="Liq-Container NewHireQueueIT">
      <Grid className="PagesFrame">
        <PageHeader />
        <Grid id="PageTitle">New Hire Queue</Grid>
        {/* Page Start */}
        <Grid xs={12} className="ContentPage">
          {/* TGS Softwares */}
          <Grid xs={12}>
            <Grid
              xs={12}
              container
              justify="space-between"
              className="LiqTables SafetyTble"
            >
              <DynamicTable tableData={hireIT} />
            </Grid>
          </Grid>
        </Grid>

        {/* Page Start End */}
      </Grid>
    </PageLayout>
  );
}

export default NewHireQueueIT;
